module.exports = __webpack_public_path__ + "static/cross-7399f9eeebe1883a28d786dcb6368835.png";